/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useState } from "react";

import styled from "styled-components";

import { Block } from "src/classes/block";
import DrilledButton from "src/components/Block/DrilledButtons/DrilledButton";
import { ConnectMenu } from "src/components/Shared/ConnectMenu";
import { Connect as ConnectIcon, Like as LikeIcon } from "src/components/UI/Icons";

interface Props {
  block: Block;
}
export function DrilledButtons({ block }: Props) {
  const isLiked = block.observe((state) => state.isLiked);
  const [connectMenuOpen, setConnectMenuOpen] = useState(false);

  return (
    <DrilledButtonsWrapper>
      <DrilledButton handleClick={() => block.like()} isSelected={isLiked}>
        <LikeIcon />
      </DrilledButton>
      <DrilledButton handleClick={() => setConnectMenuOpen(true)} isSelected={connectMenuOpen}>
        <ConnectIcon />
        {connectMenuOpen && (
          <ConnectMenu
            block={block}
            plate={null}
            closeMenu={() => setConnectMenuOpen(false)}
            blockMouseEvents={true}
          />
        )}
      </DrilledButton>
    </DrilledButtonsWrapper>
  );
}

const DrilledButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
